let Socket = ''
let setIntervalWesocketPush = null
let heardSock = false
let websocketUrl = ''
let staffId = ''
let wstoken = ''

/**
 * Socket.readyState
 * CONNECTING：值为0，表示正在连接
 * OPEN：值为1，表示连接成功，可以通信
 * CLOSING：值为2，表示连接正在关闭
 * CLOSED：值为3，表示连接已经关闭，或者打开连接失败
 */

export const createSocket = (wsUrl = '', url = '', token = '') => {
  // Socket && Socket.close()
  if (!Socket) {
    console.log('建立websocket连接')
    websocketUrl = websocketUrl || wsUrl
    staffId = staffId || url
    wstoken = wstoken || token
    console.log(websocketUrl + staffId + '/' + wstoken)
    Socket = new WebSocket(websocketUrl + staffId + '/' + wstoken)
    Socket.onopen = onopenWS
    Socket.onmessage = onmessageWS
    Socket.onerror = onerrorWS
    Socket.onclose = oncloseWS
  } else {
    console.log('websocket已连接')
  }
}

/** 打开WS之后发送心跳 */
const onopenWS = (event) => {
  console.log('onopenWS')
  sendPing()
}

/** 检测当前状态 */
export const getReadyState = () => {
  if (Socket !== null) {
    return Socket.readyState
  }
  return 3
}

/** 连接失败重连 */
const onerrorWS = () => {
  console.log('onerrorWS')
  // Socket.close()
  // clearInterval(setIntervalWesocketPush)
  if (Socket.readyState !== 3) {
    Socket = null
    // createSocket()
  }
}

/** WS数据接收统一处理 */
const onmessageWS = e => {
  let msgData = JSON.parse(e.data)
  switch (msgData.heartType) {
    case 1:
      heardSock = false
      return
    case 0:
      const heartData = {
        msgId: msgData.msgId,
        fromUser: staffId,
        toUser: ['system'],
        msgType: 'system',
        sendTime: new Date().getTime(),
        heartType: 0
      }
      if (Socket.readyState === 1) {
        Socket.send(JSON.stringify(heartData))
      }
      return
  }
  switch (msgData.msgType) {
    case 'notify':
      window.dispatchEvent(new CustomEvent('onnotifyWS', {
        detail: {
          data: e.data
        }
      }))
      break
    case 'custom':
      window.dispatchEvent(new CustomEvent('onmessageWS', {
        detail: {
          data: e.data
        }
      }))
      break
    case 'qa':
      if (msgData.heartRedict === 'answer') {
        window.dispatchEvent(new CustomEvent('onlineUserWS', {
          detail: {
            data: msgData.fromUser
          }
        }))
      } else {
        const qaData = {
          fromUser: staffId,
          toUser: [msgData.fromUser],
          msgId: uuid(),
          msgType: 'qa',
          sendTime: msgData.sendTime,
          answerTime: new Date().getTime(),
          heartRedict: 'answer'
        }
        Socket.send(JSON.stringify(qaData))
      }
      break
  }
}

/**
 * 发送数据但连接未建立时进行处理等待重发
 * @param {any} message 需要发送的数据
 */
const connecting = message => {
  setTimeout(() => {
    if (Socket.readyState === 0) {
      connecting(message)
    } else {
      Socket.send(JSON.stringify(message))
    }
  }, 1000)
}

/**
 * 发送数据
 * @param {any} message 需要发送的数据
 */
export const sendWSPush = (msgType = 'system', toUser, message) => {
  if (!Socket) return
  if (Socket !== null && Socket.readyState === 3) {
    // Socket.close()
    // createSocket()
  } else if (Socket.readyState === 1) {
    let sendMsg
    switch (msgType) {
      case 'system':
      case 'custom':
        sendMsg = {
          fromUser: staffId,
          toUser: [toUser],
          msgId: uuid(),
          msgType: msgType,
          sysCode: 'ycf',
          belongCode: 'pharmacist-distribue',
          bizCode: 'distribute-success-notify',
          body: {
            content: message,
            code: 200
          }
        }
        break
      case 'qa':
        sendMsg = {
          fromUser: staffId,
          toUser: toUser,
          msgId: uuid(),
          msgType: msgType,
          sendTime: new Date().getTime(),
          heartRedict: 'question'
        }
    }
    console.log(sendMsg)
    Socket.send(JSON.stringify(sendMsg))
  } else if (Socket.readyState === 0) {
    connecting(message)
  }
}

/** 断开重连 */
const oncloseWS = () => {
  console.log('oncloseWS')
  // clearInterval(setIntervalWesocketPush)
  if (Socket.readyState !== 2) {
    Socket = null
    // createSocket()
  }
}
/** 发送心跳
 * @param {number} time 心跳间隔毫秒 默认5000
 */
const sendPing = (time = 3000) => {
  clearInterval(setIntervalWesocketPush)
  const heartData = {
    msgId: uuid(),
    fromUser: staffId,
    toUser: ['system'],
    msgType: 'system',
    sendTime: new Date().getTime(),
    heartType: 1
  }
  // console.log(Socket)
  if (Socket && Socket.readyState === 1) {
    Socket.send(JSON.stringify(heartData))
  }
  setIntervalWesocketPush = setInterval(() => {
    // console.log(Socket)
    if (heardSock) {
      if (Socket) {
        Socket.close()
        Socket = null
      }
      createSocket()
      return
    }
    if (Socket && Socket.readyState === 1) {
      Socket.send(JSON.stringify(heartData))
    }
    heardSock = true
    setTimeout(() => {
      if (heardSock) {
        window.dispatchEvent(new CustomEvent('offline'))
        // clearInterval(setIntervalWesocketPush)
      }
    }, time - 1000)
  }, time)
}

/**
 * 主动离线
 */
export const closeSocket = () => {
  if (Socket) {
    clearInterval(setIntervalWesocketPush)
    Socket.close()
    Socket = null
  }
}

const uuid = () => {
  const s = []
  const hexDigits = '0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz'
  for (let i = 0; i < 32; i++) {
    s[i] = hexDigits.substr(Math.floor(Math.random() * 0x10), 1)
  }
  s[12] = '4' // bits 12-15 of the time_hi_and_version field to 0010
  s[16] = hexDigits.substr((s[16] & 0x3) | 0x8, 1) // bits 6-7 of the clock_seq_hi_and_reserved to 01
  const uuid = s.join('')
  return uuid
}
